/* Translations */
import i18n from '../../../../i18n';

interface IFullDate {
  getDaysDifference(dateToCompare: FullDate): number;
  format(ft: DateFormatType): string;
  addDays(days: number): FullDate;
  unformat(): string;
}

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

type DateFormatType =
  | 'DD'
  | 'MM'
  | 'Month'
  | 'YYYY'
  | 'HH'
  | 'mm'
  | 'DD/MM/YYYY - HH:mm'
  | 'DD/MM/YYYY'
  | 'DD/MM/YY'
  | 'HH:mm'
  | 'DD Month HH:mm'
  | 'DD Month';

export class FullDate implements IFullDate {
  readonly date: Date;

  constructor(date: string) {
    const newDate = new Date(date);
    if (newDate.toString() === 'Invalid Date') {
      throw new Error('Invalid Date');
    }

    this.date = newDate;
  }

  public format(ft: DateFormatType): string {
    const day = this.zeroPad(this.date.getDate());
    const month = this.zeroPad(this.date.getMonth() + 1);
    const monthName = i18n.t(`translation:${MONTHS[this.date.getMonth()]}`);
    const year = this.date.getFullYear();

    const hours = this.zeroPad(this.date.getHours());
    const minutes = this.zeroPad(this.date.getMinutes());

    switch (ft) {
      case 'DD':
        return `${day}`;
      case 'MM':
        return `${month}`;
      case 'Month':
        return `${monthName}`;
      case 'YYYY':
        return `${year}`;
      case 'HH':
        return `${hours}`;
      case 'mm':
        return `${minutes}`;
      case 'HH:mm':
        return `${hours}:${minutes}`;
      case 'DD Month':
        return `${day} ${monthName}`;
      case 'DD Month HH:mm':
        return `${day} ${monthName} ${hours}:${minutes}`;
      case 'DD/MM/YY':
        return `${day}/${month}/${year.toString().substring(2)}`;
      case 'DD/MM/YYYY':
        return `${day}/${month}/${year}`;
      case 'DD/MM/YYYY - HH:mm': {
        return `${day}/${month}/${year} - ${hours}:${minutes}`;
      }
    }
  }

  public unformat(): string {
    return this.date.toISOString();
  }

  public getDaysDifference(dateToCompare: FullDate): number {
    if (this.format('DD/MM/YYYY') === dateToCompare.format('DD/MM/YYYY')) {
      return 0;
    }

    const diffTime = Math.abs(
      (this.date as unknown as number) -
        (dateToCompare.date as unknown as number),
    );

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  public addDays(days: number): FullDate {
    this.date.setDate(this.date.getDate() + days);

    return this;
  }

  private zeroPad(number: number): string {
    const strNumber = number.toString();
    return strNumber.length === 1 ? `0${strNumber}` : strNumber;
  }
}
